import { action } from 'typesafe-actions';
import {
  ICompetitionWatchlistPair,
  ITicker,
  IWatchedTicker,
  enums,
} from '@kattana-io/common';
import {
  UpdateWatchlistItemPayload,
  WatchlistTab,
} from '../reducers/watchlist';

const entity = 'watchlist';
const ADD = `${entity}/ADD`;
const ADD_SUCCESS = `${entity}/ADD_SUCCESS`;
const REMOVE = `${entity}/REMOVE`;
const REMOVE_SUCCESS = `${entity}/REMOVE_SUCCESS`;
const UPDATE = `${entity}/UPDATE_PAIR`;
const UPDATE_SUCCESS = `${entity}/UPDATE_SUCCESS`;
const ACTIVATE = `${entity}/ACTIVATE`;
const SET_TAB = `${entity}/SET_TAB`;
const SET_WATCHED = `${entity}/SET_WATCHED`;
const SET_GAINERS = `${entity}/SET_GAINERS`;
const SET_TVL = `${entity}/SET_TVL`;
const SET_COMPETITION = `${entity}/SET_COMPETITION`;
const SET_TICKERS = `${entity}/SET_TICKERS`;
const SET_LOADING = `${entity}/SET_LOADING`;

const actionActivateWatchlist = () => action(ACTIVATE);
const actionAddWatchlist = (
  item: ITicker,
  tag?: enums.Tag,
  callback?: () => void
) => action(ADD, { item, tag, callback });
const actionAddSuccessWatchlist = (item: IWatchedTicker) =>
  action(ADD_SUCCESS, item);
const actionRemoveWatchlist = (id: number, callback?: () => void) =>
  action(REMOVE, { id, callback });
const actionRemoveSuccessWatchlist = (id: number) => action(REMOVE_SUCCESS, id);
const actionUpdateWatchlist = (
  id: number,
  payload: UpdateWatchlistItemPayload
) => action(UPDATE, { id, payload });
const actionUpdateSuccessWatchlist = (
  id: number,
  payload: UpdateWatchlistItemPayload
) => action(UPDATE_SUCCESS, { id, payload });
const actionSetWatchlistWatched = (items: Array<ITicker | IWatchedTicker>) =>
  action(SET_WATCHED, items);
const actionSetWatchlistTab = (tab: WatchlistTab) => action(SET_TAB, tab);
const actionSetWatchlistGainers = (items: ITicker[]) =>
  action(SET_GAINERS, items);
const actionSetWatchlistTVL = (items: ITicker[]) => action(SET_TVL, items);
const actionSetWatchlistCompetition = (items: ICompetitionWatchlistPair[]) =>
  action(SET_COMPETITION, items);
const actionSetWatchlistTickers = (items: Array<ITicker | IWatchedTicker>) =>
  action(SET_TICKERS, items);
const actionSetWatchlistLoading = (loading: boolean) =>
  action(SET_LOADING, loading);

export {
  ADD,
  ADD_SUCCESS,
  REMOVE,
  REMOVE_SUCCESS,
  UPDATE,
  UPDATE_SUCCESS,
  ACTIVATE,
  SET_TAB,
  SET_WATCHED,
  SET_GAINERS,
  SET_TVL,
  SET_COMPETITION,
  SET_TICKERS,
  SET_LOADING,
  actionAddWatchlist,
  actionAddSuccessWatchlist,
  actionRemoveWatchlist,
  actionRemoveSuccessWatchlist,
  actionUpdateWatchlist,
  actionUpdateSuccessWatchlist,
  actionActivateWatchlist,
  actionSetWatchlistTab,
  actionSetWatchlistWatched,
  actionSetWatchlistGainers,
  actionSetWatchlistTVL,
  actionSetWatchlistCompetition,
  actionSetWatchlistTickers,
  actionSetWatchlistLoading,
};
